import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "export-modal" }
const _hoisted_2 = {
  key: 0,
  class: "spinner"
}
const _hoisted_3 = { class: "export-modal__select-all" }
const _hoisted_4 = { class: "export-modal__stage-list" }
const _hoisted_5 = { class: "export-modal__stage-info" }
const _hoisted_6 = { class: "export-modal__stage-name" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    "is-open": $setup.props.isOpen,
    onClose: $setup.onClose,
    classes: "without-padding height-limited"
  }, {
    content: _withCtx(() => [
      _createVNode($setup["FormModalLayout"], {
        title: "Export Contacts",
        onBack: $setup.onClose
      }, {
        footer: _withCtx(() => [
          _createElementVNode("button", {
            class: "button default cancel",
            onClick: $setup.onClose
          }, "Cancel"),
          _createElementVNode("button", {
            class: "button default primary export-modal__action",
            disabled: !$setup.hasSelection || $setup.exporting,
            onClick: $setup.onExport
          }, [
            ($setup.exporting)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, [...(_cache[2] || (_cache[2] = [
                  _createElementVNode("span", { class: "export-modal__spinner" }, null, -1),
                  _createTextVNode("Exporting...", -1)
                ]))]))
              : (_openBlock(), _createElementBlock("span", _hoisted_9, "Export"))
          ], 8, _hoisted_7)
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _cache[1] || (_cache[1] = _createElementVNode("p", { class: "export-modal__subtitle" }, "Only contacts with an approved contract form are included.", -1)),
            ($setup.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode($setup["CheckboxInput"], {
                      modelValue: $setup.isAllSelected,
                      checkedPartial: $setup.isSomeSelected && !$setup.isAllSelected,
                      label: "Select all stages",
                      "onUpdate:modelValue": $setup.toggleAll
                    }, null, 8, ["modelValue", "checkedPartial"])
                  ]),
                  _cache[0] || (_cache[0] = _createElementVNode("div", { class: "export-modal__divider" }, null, -1)),
                  _createElementVNode("div", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.stages, (stage) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(["export-modal__stage-item", { 'export-modal__stage-item--disabled': $setup.getStageContactsCount(stage._id) === 0 }]),
                        key: stage._id
                      }, [
                        _createVNode($setup["CheckboxInput"], {
                          modelValue: $setup.selectedStageIds[stage._id],
                          "onUpdate:modelValue": ($event: any) => (($setup.selectedStageIds[stage._id]) = $event),
                          disabled: $setup.getStageContactsCount(stage._id) === 0
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]),
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("span", _hoisted_6, "Stage " + _toDisplayString(stage.title), 1),
                          _createElementVNode("span", {
                            class: _normalizeClass(["export-modal__stage-tag", { 'export-modal__stage-tag--empty': $setup.getStageContactsCount(stage._id) === 0 }])
                          }, _toDisplayString($setup.formatContactsCount($setup.getStageContactsCount(stage._id))), 3)
                        ])
                      ], 2))
                    }), 128))
                  ])
                ], 64))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["is-open"]))
}